import styled from 'styled-components'

export const StyledHeader = styled.h1`
  font-size: 30px;
  font-family: 'Golos Text Sans', sans-serif;
  margin-bottom: 24px;
  font-weight: bolder;
`

export const StyledEmphasis = styled.span`
  font-size: inherit;
  font-weight: inherit;
  font-family: inherit;
  color: #0e78fa;
`

export const MainWrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 40%;
  min-width: 400px;
  padding: 40px;
`

export const ListWrapper = styled.li`
  list-style: none;
`
